import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.campaignSelected) {
        return {
          value: action.campaignSelected.id,
          campaign: { ...action.campaignSelected },
        }
      }
      return null
    default:
      return state
  }
}
